import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_EXECUTIONS_REQUEST = "FETCH_EXECUTIONS_REQUEST";
export const FETCH_EXECUTIONS_SUCCESS = "FETCH_EXECUTIONS_SUCCESS";
export const FETCH_EXECUTIONS_ERROR = "FETCH_EXECUTIONS_ERROR";
export const CREATE_EXECUTIONS_REQUEST = "CREATE_EXECUTIONS_REQUEST";
export const CREATE_EXECUTIONS_SUCCESS = "CREATE_EXECUTIONS_SUCCESS";
export const CREATE_EXECUTIONS_ERROR = "CREATE_EXECUTIONS_ERROR";

export const readExecutions = () => {
    return async (dispatch) => {
        try {
            dispatch(fetchExecutionsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.get('/api/executions', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchExecutionsSuccess, fetchExecutionsError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchExecutionsError));
        }
    };
};

const fetchExecutionsRequest = () => {
    return {
        type: FETCH_EXECUTIONS_REQUEST
    };
};

const fetchExecutionsSuccess = (payload) => {
    return {
        type: FETCH_EXECUTIONS_SUCCESS,
        payload
    };
};

const fetchExecutionsError = (errorMessage) => {
    return {
        type: FETCH_EXECUTIONS_ERROR,
        errorMessage
    };
};

export const createExecutions = (userId, type) => {
    return async (dispatch) => {
        try {
            dispatch(createExecutionsRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/executions/create', {user: userId, type: type}, { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }});

            dispatch(utilsLib.response(res, createExecutionsSuccess, createExecutionsError));
        } catch (err) {
            dispatch(utilsLib.response(err, createExecutionsError));
        }
    };
};

const createExecutionsRequest = () => {
    return {
        type: CREATE_EXECUTIONS_REQUEST
    };
};

const createExecutionsSuccess = (payload) => {
    return {
        type: CREATE_EXECUTIONS_SUCCESS,
        payload
    };
};

const createExecutionsError = (errorMessage) => {
    return {
        type: CREATE_EXECUTIONS_ERROR,
        errorMessage
    };
};

